module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-13 at 04.42.06.f26f9a3a.png";